import { ThemeMode, toBinaryThemeMode } from '@app/core/ui/theme-mode';

/**
 * Builds the full URL to open a video editor session, including auth query params.
 * Used by links and by programmatic navigation after creating an edit.
 * The external video editor still reads `projectId` in the query string; we pass the edit id there.
 * `theme` is mapped to binary light/dark because the editor does not understand `light-full`.
 */
export function buildVideoEditorEditUrl(options: {
  baseUrl: string;
  editId: string;
  jwt: string;
  theme: ThemeMode;
  authAsUserId?: string;
}): string {
  const url = new URL(options.baseUrl);
  url.searchParams.set('edit', options.editId);
  url.searchParams.set('jwt', options.jwt);
  url.searchParams.set('theme', toBinaryThemeMode(options.theme));
  if (options.authAsUserId) {
    url.searchParams.set('auth_as', options.authAsUserId);
  }
  return url.toString();
}
